<template>
  <div class="d-flex flex-column flex-root">
    <div
      class="login login-1 d-flex flex-column flex-lg-row flex-column-fluid bg-white login-forgot-on"
    >
      <!--begin::Content-->
      <div
        class="login-content flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden p-7 mx-auto"
      >
        <!-- Elementos decorativos -->
        <div class="login-blob login-blob--top"></div>
        <div class="login-blob login-blob--bottom"></div>
        <div class="login-dots"></div>
        <div class="login-ring"></div>

        <div class="d-flex flex-column-fluid flex-center">
          <!--begin::Forgot-->
          <div class="login-form login-forgot">
            <div class="login-card">
              <!--begin::Form-->
              <form
                class="form"
                novalidate="novalidate"
                id="kt_validar_2fa_form"
                ref="kt_validar_2fa_form"
              >
                <div class="login-card-header">
                  <h3 class="login-title">Autenticação de dois fatores</h3>
                  <p class="login-subtitle">
                    <template v-if="usaApp2FA">
                      Digite o código gerado no seu aplicativo autenticador
                    </template>
                    <template v-else>
                      Digite o código que enviamos para seu telefone e/ou email
                    </template>
                  </p>
                </div>

                <FAInput
                  @codigo:atualizado="atualizarCodigo2FA"
                  @enter="enter"
                />

                <div class="d-flex w-100 pt-2 pb-4">
                  <div v-if="!usaApp2FA" class="w-100 mr-2">
                    <button
                      type="button"
                      id="kt_login_validar2fa_reenviar"
                      ref="kt_login_validar2fa_reenviar"
                      class="btn modern-btn-cancel font-weight-bolder w-100"
                      @click.prevent="reenviar2FA"
                    >
                      Reenviar
                    </button>
                  </div>

                  <div class="w-100">
                    <button
                      type="submit"
                      id="kt_login_validar2fa_submit"
                      ref="kt_login_validar2fa_submit"
                      class="btn modern-btn-primary font-weight-bolder w-100"
                    >
                      Confirmar
                    </button>
                  </div>
                </div>
                <p class="recaptcha-disclaimer">
                  Este site é protegido pelo reCAPTCHA. A
                  <a href="https://policies.google.com/privacy"
                    >Política de Privacidade</a
                  >
                  e os
                  <a href="https://policies.google.com/terms"
                    >Termos de Serviço</a
                  >
                  do Google se aplicam.
                </p>
              </form>
            </div>
          </div>
          <!--end::Forgot-->
        </div>
      </div>
      <!--end::Content-->
      <!--begin::Aside-->
      <div
        class="login-aside diagonal-aside d-flex flex-column flex-row-auto justify-content-center"
        style="background-color: #ff7900"
      >
        <a href="#" class="text-center">
          <img
            src="/media/comunicante/logo-wellon-login.png"
            class="img-login1"
            alt=""
          />
        </a>
      </div>
      <!--begin::Aside-->
    </div>
  </div>
</template>

<!-- Load login custom page styles -->
<style lang="scss">
@import "@/assets/sass/pages/login/login-1.scss";
</style>

<script>
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import SubmitButton from "@/assets/plugins/formvalidation/dist/es6/plugins/SubmitButton";

import KTUtil from "@/assets/js/components/util";
import { mapGetters } from "vuex";
import { VALIDAR_2FA, REENVIAR_2FA } from "@/core/services/store/auth.module";
import Swal from "sweetalert2";

import FAInput from "./2FAInput";

export default {
  name: "autenticaca-dois-fatores",

  components: {
    FAInput
  },

  data() {
    return {
      form: {
        codigo: "",
        token: ""
      }
    };
  },
  computed: {
    ...mapGetters(["validatorErrors", "currentUser"]),

    usaApp2FA() {
      return !!this.currentUser && this.currentUser.canal_2fa === "A";
    },

    backgroundImage() {
      return process.env.BASE_URL + "media/comunicante/bg-login.svg";
    }
  },
  mounted() {
    const validar2fa_form = KTUtil.getById("kt_validar_2fa_form");

    this.fv1 = formValidation(validar2fa_form, {
      fields: {
        codigo: {
          validators: {
            notEmpty: {
              message: "Campo obrigatório."
            },
            stringLength: {
              min: 6,
              max: 6,
              message: "Informe o código com 6 dígitos."
            },
            blank: {}
          }
        }
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap()
      }
    });

    this.fv1.on("core.form.valid", async () => {
      const submitButton = this.$refs["kt_login_validar2fa_submit"];
      submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      await this.$recaptchaLoaded();
      this.form.token = await this.$recaptcha("login");

      this.$store
        .dispatch(VALIDAR_2FA, this.form)
        .then(() => {
          this.$router.push("/");
        })
        .catch(() => {
          for (const error in this.validatorErrors) {
            this.fv
              .updateValidatorOption(
                error,
                "blank",
                "message",
                this.validatorErrors[error]
              )
              .updateFieldStatus(error, "Invalid", "blank");
          }
        })
        .finally(() => {
          submitButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        });
    });
  },

  methods: {
    async reenviar2FA() {
      const reenviarButton = this.$refs["kt_login_validar2fa_reenviar"];
      reenviarButton.classList.add("spinner", "spinner-light", "spinner-right");

      await this.$recaptchaLoaded();
      this.form.token = await this.$recaptcha("login");

      this.$store
        .dispatch(REENVIAR_2FA, this.form)
        .then(() => {
          this.form.codigo = "";
          this.form.token = "";

          Swal.fire({
            title: "MENSAGEM: ",
            text: "Uma mensagem com um novo código foi enviado para você, verifique seu telefone ou email!",
            icon: "success",
            confirmButtonClass: "btn btn-success",
            heightAuto: false
          });
        })
        .catch(() => {
          for (const error in this.validatorErrors) {
            this.fv
              .updateValidatorOption(
                error,
                "blank",
                "message",
                this.validatorErrors[error]
              )
              .updateFieldStatus(error, "Invalid", "blank");
          }
        })
        .finally(() => {
          reenviarButton.classList.remove(
            "spinner",
            "spinner-light",
            "spinner-right"
          );
        });
    },

    enter(numberInput) {
      const submitButton = this.$refs.kt_login_validar2fa_submit;
      if (submitButton) {
        submitButton.click(); // Simula o clique no botão
      }
    },

    atualizarCodigo2FA(codigo) {
      this.form.codigo = codigo;
    }
  }
};
</script>

<style scoped>
.diagonal-aside {
  margin-top: -25em;
  margin-left: -5em;
  background: #ffffff;
  overflow: hidden;
  -webkit-transform: skew(16deg) translateX(100px);
  -ms-transform: skew(16deg) translateX(100px);
  transform: skew(16deg) translateX(100px);
  left: 0;
}

.diagonal-aside img {
  width: auto;
  max-width: 75%;
  max-height: 85vh;
  margin-left: -20em;
  margin-top: 25em;
  -webkit-transform: skew(-16deg) translateX(40px);
  -ms-transform: skew(-16deg) translateX(40px);
  transform: skew(-16deg) translateX(40px);
  left: 0;
  object-fit: contain;
}

@media screen and (max-width: 768px) {
  .diagonal-aside {
    display: none;
  }
}

.login-content {
  max-width: 100% !important;
}

.login-card {
  background: #ffffff;
  border-radius: 20px;
  padding: 2.75rem 2.5rem;
  box-shadow: 0 10px 40px rgba(72, 33, 130, 0.08),
    0 2px 8px rgba(72, 33, 130, 0.06);
  max-width: 440px;
  width: 100%;
  position: relative;
  z-index: 1;
}

.login-card-header {
  margin-bottom: 1.75rem;
}

.login-title {
  font-size: 1.6rem;
  font-weight: 600;
  color: #482182;
  margin-bottom: 0.35rem;
}

.login-subtitle {
  color: #9a9ab0;
  font-size: 0.95rem;
  font-weight: 400;
  margin-bottom: 0;
}

.modern-btn-primary {
  height: 50px;
  background-color: #482182;
  border: none;
  border-radius: 12px;
  color: #ffffff;
  font-size: 1rem;
  box-shadow: 0 4px 14px rgba(72, 33, 130, 0.25);
  transition: transform 0.15s ease, box-shadow 0.15s ease,
    background-color 0.15s ease;
}

.modern-btn-primary:hover {
  background-color: #3a1a6a;
  box-shadow: 0 6px 18px rgba(72, 33, 130, 0.32);
  transform: translateY(-1px);
}

.modern-btn-cancel {
  height: 50px;
  border: 1.5px solid #e4e4ef;
  border-radius: 12px;
  color: #482182;
  background-color: #ffffff;
  font-size: 1rem;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

.modern-btn-cancel:hover {
  background-color: #f9f9fc;
  border-color: #d8d8ea;
}

.recaptcha-disclaimer {
  color: #b3b3c6;
  font-size: 0.75rem;
  line-height: 1.5;
  margin-bottom: 0;
}

.recaptcha-disclaimer a {
  color: #6b6b80;
  text-decoration: underline;
}

/* Elementos decorativos */
.login-blob {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  z-index: 0;
}

.login-blob--top {
  top: -90px;
  left: -110px;
  width: 280px;
  height: 280px;
  background: radial-gradient(
    circle,
    rgba(72, 33, 130, 0.16) 0%,
    rgba(72, 33, 130, 0) 70%
  );
}

.login-blob--bottom {
  bottom: -140px;
  left: 18%;
  width: 340px;
  height: 340px;
  background: radial-gradient(
    circle,
    rgba(72, 33, 130, 0.12) 0%,
    rgba(72, 33, 130, 0) 70%
  );
}

.login-dots {
  position: absolute;
  top: 32px;
  left: 32px;
  width: 88px;
  height: 88px;
  background-image: radial-gradient(
    rgba(72, 33, 130, 0.28) 1.5px,
    transparent 1.5px
  );
  background-size: 16px 16px;
  pointer-events: none;
  z-index: 0;
}

.login-ring {
  position: absolute;
  bottom: 48px;
  left: 6%;
  width: 36px;
  height: 36px;
  border: 6px solid rgba(72, 33, 130, 0.14);
  border-radius: 50%;
  pointer-events: none;
  z-index: 0;
}

@media screen and (max-width: 576px) {
  .login-card {
    padding: 2rem 1.5rem;
    box-shadow: none;
  }
  .login-blob,
  .login-dots,
  .login-ring {
    display: none;
  }
}
</style>
